import fetchAllReasonsImport from './fetchAllReasons';
import fetchLenderDetailsImport from './fetchLenderDetails';
import fetchLendersImport from './fetchLenders';
import fetchMissedPaymentsImport from './fetchMissedPayments';
import fetchSuggestionsImport from './fetchSuggestions';
import postResolveImport from './postResolve';
import postTullyRegistrationImport from './postTullyRegistration';
import putReasonsImport from './putReasons';

export const fetchAllReasons = fetchAllReasonsImport;
export const fetchLenderDetails = fetchLenderDetailsImport;
export const fetchLenders = fetchLendersImport;
export const fetchMissedPayments = fetchMissedPaymentsImport;
export const fetchSuggestions = fetchSuggestionsImport;
export const postResolve = postResolveImport;
export const postTullyRegistration = postTullyRegistrationImport;
export const putReasons = putReasonsImport;
